import { h, Fragment } from "preact";
import { useReducer } from "preact/hooks";

import { nanoid } from "nanoid";
import { showModal } from "../../modal";
import Api from "../../api";

import { IManuallyEbook, IManuallyChapter } from "@hibas123/lib-ebs";
import Navigation, { Pages } from "../../navigation";

type ActionTypes =
   | { type: "setTitle"; value: string }
   | { type: "setAuthor"; value: string }
   | { type: "setSummary"; value: string }
   | { type: "setCover"; value: string }
   | { type: "setWorkID"; value: string }
   | { type: "addTag"; value: string }
   | { type: "removeTag"; value: string }
   | { type: "setChapter"; value: IManuallyChapter }
   | { type: "removeChapter"; value: string };

function reducer(state: IManuallyEbook, action: ActionTypes): IManuallyEbook {
   switch (action.type) {
      case "setTitle":
         state = { ...state, title: action.value as string };
         break;
      case "setCover":
         state = { ...state, cover: action.value as string };
         break;
      case "setSummary":
         state = { ...state, summary: action.value as string };
         break;
      case "setAuthor":
         state = { ...state, author: action.value as string };
         break;
      case "setWorkID":
         state = { ...state, workid: action.value as string };
         break;
      case "addTag":
         state = {
            ...state,
            tags: [
               ...state.tags.filter((e) => e != action.value),
               action.value,
            ],
         };
         break;
      case "removeTag":
         state = {
            ...state,
            tags: state.tags.filter((e) => e !== action.value),
         };
         break;
      case "setChapter":
         let a = [...state.chapters];
         let idx = a.findIndex((e) => e.id === action.value.id);
         if (idx >= 0) {
            a[idx] = action.value;
         } else {
            a.push(action.value);
         }
         state = {
            ...state,
            chapters: a,
         };
         break;
      case "removeChapter":
         state = {
            ...state,
            chapters: state.chapters.filter((e) => e.id !== action.value),
         };

         break;
      default:
         return state;
   }

   localStorage.setItem("ebook-editor-temp", JSON.stringify(state));

   return state;
}

function initState(initialState: IManuallyEbook) {
   let state = JSON.parse(JSON.stringify(initialState));
   let old = localStorage.getItem("ebook-editor-temp");
   if (old && old !== "") {
      try {
         let s = JSON.parse(old);
         state = { ...state, ...s };
      } catch {}
   }
   return state;
}

type Reducer = {
   state: IManuallyEbook;
   dispatch: (action: ActionTypes) => void;
};

function EditWork({ state, dispatch }: Reducer) {
   return (
      <div>
         <div class="input-group">
            <label for="title">Title</label>
            <input
               type="text"
               id="title"
               autofocus
               value={state.title}
               onChange={(e) =>
                  dispatch({
                     type: "setTitle",
                     value: (e.target as HTMLInputElement).value,
                  })
               }
            />
         </div>

         <div class="input-group">
            <label for="author">Author</label>
            <input
               type="text"
               id="author"
               autofocus
               value={state.author}
               onChange={(e) =>
                  dispatch({
                     type: "setAuthor",
                     value: (e.target as HTMLInputElement).value,
                  })
               }
            />
         </div>

         <div class="input-group">
            <label for="summary">Summary</label>
            <textarea
               type="text"
               id="summary"
               autofocus
               value={state.summary}
               rows={20}
               onChange={(e) =>
                  dispatch({
                     type: "setSummary",
                     value: (e.target as HTMLInputElement).value,
                  })
               }
            />
         </div>

         <div class="input-group">
            <label for="cover">Cover</label>
            <input
               type="text"
               id="cover"
               autofocus
               value={state.cover}
               onChange={(e) =>
                  dispatch({
                     type: "setCover",
                     value: (e.target as HTMLInputElement).value,
                  })
               }
            />
         </div>

         <div class="input-group">
            <label for="description">Description</label>
            <input
               type="text"
               id="description"
               autofocus
               value={state.workid}
               onChange={(e) =>
                  dispatch({
                     type: "setWorkID",
                     value: (e.target as HTMLInputElement).value,
                  })
               }
            />
         </div>
      </div>
   );
}
const emptyBook: IManuallyEbook = {
   title: "",
   author: "",
   cover: "",
   summary: "",
   chapters: [],
   tags: [],
   type: "manually",
   workid: "",
};

function showChapterModal(
   chapter: IManuallyChapter,
   save: () => void,
   rm: () => void
) {
   const controls = showModal(() => {
      return (
         <Fragment>
            <div className="modal-title">Add</div>
            <div className="modal-content">
               <div class="input-group">
                  <label for="title">Title</label>
                  <input
                     type="text"
                     id="title"
                     autofocus
                     value={chapter.title}
                     onChange={(e) =>
                        (chapter.title = (e.target as HTMLInputElement).value)
                     }
                  />
               </div>
               <div class="input-group">
                  <label for="content">Content</label>
                  <textarea
                     type="text"
                     id="content"
                     autofocus
                     value={chapter.content}
                     rows={20}
                     onChange={(e) =>
                        (chapter.content = (e.target as HTMLInputElement).value)
                     }
                  />
               </div>
            </div>
            <div class="modal-action">
               <button
                  class="btn btn-error"
                  onClick={() => {
                     rm();
                     controls.close();
                  }}
               >
                  Delete
               </button>
               <button
                  class="btn btn-primary"
                  onClick={() => {
                     save();
                     controls.close();
                  }}
               >
                  Save
               </button>
            </div>
         </Fragment>
      );
   });
}

export default function EditorPage() {
   const [state, dispatch] = useReducer(reducer, emptyBook, initState);
   console.log(state);
   // const [];
   return (
      <div class="container" style="margin-top:1rem">
         <EditWork state={state} dispatch={dispatch} />
         <h3 style="margin-bottom: .5rem">Chapters:</h3>
         {state.chapters.length <= 0 ? (
            <h4 style="margin-left: 1rem">No Chapters</h4>
         ) : (
            <ul class="list list-divider list-clickable">
               {state.chapters.map((e) => (
                  <li
                     onClick={() => {
                        showChapterModal(
                           e,
                           () => {
                              dispatch({ type: "setChapter", value: e });
                           },
                           () => {
                              dispatch({ type: "removeChapter", value: e.id });
                           }
                        );
                     }}
                  >
                     {e.title}
                  </li>
               ))}
            </ul>
         )}
         <button
            onClick={() => {
               const c = {
                  id: nanoid(),
                  content: "",
                  title: "",
               };
               showChapterModal(
                  c,
                  () => {
                     dispatch({ type: "setChapter", value: c });
                  },
                  () => null
               );
            }}
            class="btn btn-secondary"
            style="margin-top: .5rem"
         >
            Add
         </button>
         <br />
         <div style="display: flex">
            <button
               onClick={async () => {
                  // TODO: Validation
                  await new Promise((resolve) => {
                     const ctrls = showModal(() => {
                        return (
                           <Fragment>
                              <div className="modal-title">Review</div>
                              <div className="modal-content">
                                 <code style="white-space: pre">
                                    {JSON.stringify(state, null, "   ")}
                                 </code>
                              </div>
                              <br />
                              <div className="modal-actions">
                                 <button
                                    class="btn"
                                    onClick={() => {
                                       ctrls.close();
                                       resolve();
                                    }}
                                 >
                                    Save
                                 </button>
                                 <button
                                    class="btn"
                                    onClick={() => ctrls.close()}
                                 >
                                    Cancel
                                 </button>
                              </div>
                           </Fragment>
                        );
                     });
                  });

                  console.log("Add work");

                  await Api.addManualWork(state)
                     .then(() => {
                        alert("Success!");
                        Navigation.setPage(Pages.Library, undefined);
                     })
                     .catch((err) => {
                        console.log(err);
                        alert("Error: " + err.message);
                     });
               }}
               class="btn btn-success"
               style="margin-left:auto; margin-top: .5rem"
            >
               Save
            </button>
         </div>
      </div>
   );
}
